import { Sidebar, BottomNav } from "./Sidebar";
import { TrialBanner } from "./TrialBanner";
import { ActiveJobsIndicator } from "./ActiveJobsIndicator";

export function AppShell({ children }) {
    return (
        <div className="min-h-screen bg-brand-cream">
            <div className="print:hidden">
                <Sidebar />
                <BottomNav />
                <ActiveJobsIndicator />
            </div>
            <main className="lg:pl-[260px] pb-24 lg:pb-0 min-h-screen print:!pl-0 print:!pb-0">
                <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12 py-6 lg:py-10 print:!p-0 print:!max-w-none">
                    <div className="print:hidden">
                        <TrialBanner />
                    </div>
                    {children}
                </div>
                <footer className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12 pb-8 pt-4 print:hidden">
                    <div className="border-t border-brand-line pt-4 flex items-center justify-center gap-4 text-[11px] uppercase tracking-[0.18em] text-brand-muted">
                        <a href="/privacy-policy" className="hover:text-brand-navy transition-colors" data-testid="footer-privacy-link">
                            Privacy
                        </a>
                        <span className="text-brand-line">·</span>
                        <a href="/cookie-policy" className="hover:text-brand-navy transition-colors" data-testid="footer-cookie-link">
                            Cookie Policy
                        </a>
                    </div>
                </footer>
            </main>
        </div>
    );
}

export function PageHeader({ eyebrow, title, subtitle, right }) {
    return (
        <div className="flex items-end justify-between gap-6 flex-wrap mb-8 animate-fade-up">
            <div>
                {eyebrow && (
                    <div className="eyebrow text-brand-gold mb-2">{eyebrow}</div>
                )}
                <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-[1.05]">
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-2 text-sm sm:text-base text-brand-muted max-w-2xl">
                        {subtitle}
                    </p>
                )}
            </div>
            {right && <div className="flex items-center gap-3">{right}</div>}
        </div>
    );
}
